import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TlumaczeniaService } from 'src/app/core/tlumaczenia/serwisy/tlumaczenia.service';
import { TlumaczeniaNazw } from '../../../modele/tlumaczenia-nazw';
import { InformacjeOObiekcie } from '../../../utils/obiekty-mapy-utils';
import { Router } from '@angular/router';
import { ObiektyWynikDto } from 'src/app/wspolne/interfejsy/wyszukiwarka-glowna';

@Component({
  selector: 'mm-obiekt-opis',
  templateUrl: './obiekt-opis.component.html',
  styleUrls: ['./obiekt-opis.component.scss']
})
export class ObiektOpisComponent implements OnInit, OnDestroy {

  @Input()
  nazwaWarstwy?: TlumaczeniaNazw;

  @Input()
  obiekt?: InformacjeOObiekcie;

  aktualnyJezyk = '';
  zmianaJezykaSubscription?: Subscription;

  /**
   * KOnstruktor
   * @param tlumaczenia
   */
  constructor(private tlumaczenia: TlumaczeniaService, private router: Router) { }

  /**
   * Cykl życia komponentu inicjalizacja
   */
  ngOnInit(): void {
    this.zmianaJezykaSubscription = this.tlumaczenia.getZmianaJezykaSubject().subscribe(jezyk => {
      this.aktualnyJezyk = jezyk;
    })
  }

  /**
   * Cykl życia komponentu niszczenie
   */
  ngOnDestroy(): void {
    if (this.zmianaJezykaSubscription) {
      this.zmianaJezykaSubscription.unsubscribe();
    }
  }
  przekierujMape(uuid_mapy?: string): void {

    this.router.navigate(['/mapa',uuid_mapy], { queryParams: { lang: this.aktualnyJezyk } });
  }
  przekierujObiektNaMape(obiekt: InformacjeOObiekcie): void {

    let queryParams
      = {
      zoom: 14,
      srodekX: obiekt.typ === '2001' ? obiekt.geometria?.getOrdinates().at(0) : obiekt.geometria?.getMBR().getCenter().getX(),
      srodekY: obiekt.typ === '2001' ? obiekt.geometria?.getOrdinates().at(1) : obiekt.geometria?.getMBR().getCenter().getY(),
      lokalizacjaX: obiekt.typ === '2001' ? obiekt.geometria?.getOrdinates().at(0) : obiekt.geometria?.getMBR().getCenter().getX(),
      lokalizacjaY: obiekt.typ === '2001' ? obiekt.geometria?.getOrdinates().at(1) : obiekt.geometria?.getMBR().getCenter().getY(),
      lang: this.aktualnyJezyk
    }

    this.router.navigate(['/mapa', obiekt.uuid_mapy], {

      queryParams

    });
  }
}
